export interface GossipCategory {
  name: string;
  slug: string;
  icon: string;
  count: number;
  desc: string;
}

export const gossipCategories: GossipCategory[] = [
  {
    name: "娱乐八卦",
    slug: "entertainment",
    icon: "ri-vip-crown-2-line",
    count: 128,
    desc: "颁奖礼、后台花絮与各种现场小插曲，按事件串完整还原。",
  },
  {
    name: "影视热剧",
    slug: "drama",
    icon: "ri-movie-2-line",
    count: 96,
    desc: "从选角、开机到播出反馈，追一部剧从诞生到口碑的全过程。",
  },
  {
    name: "音乐现场",
    slug: "music",
    icon: "ri-music-2-line",
    count: 74,
    desc: "音乐节、演唱会与巡演话题，票务与现场体验逐条记录。",
  },
  {
    name: "综艺观察",
    slug: "variety",
    icon: "ri-live-line",
    count: 63,
    desc: "镜头语言、剪辑节奏与嘉宾互动，看懂节目背后的制作逻辑。",
  },
  {
    name: "网红动态",
    slug: "influencer",
    icon: "ri-live-line",
    count: 88,
    desc: "直播间、短视频与内容创作话题，把流量背后的争议讲清楚。",
  },
  {
    name: "品牌公关",
    slug: "brand",
    icon: "ri-store-3-line",
    count: 52,
    desc: "代言、物料与回应节奏，观察一次处理得漂亮或糟糕的公关。",
  },
];